export default __webpack_public_path__ + "static/media/cyclops_6.c5d05ff3.svg";